<template>
  <div>
    <router-link
      :to="{ name: 'publicDish', params: { id: item.dish.id, slug: item.dish.slug_restaurant, lang: language } }"
      class="vx-row bg-white rounded-lg p-4 md:p-6 shadow mb-4"
    >
      <div class="sm:w-1/5 md:w-1/6 w-full">
        <img class="w-auto rounded mx-auto" :src="getImage(item.dish.images)" />
      </div>
      <div class="sm:w-3/5 md:w-4/6 w-full sm:pl-6">
        <h3 class="flex-none text-base font-bold mb-3">{{ item.dish.name }}</h3>
        <div id="alergy" class="mt-2 sm:w-2/3">
          <div class="flex flex-wrap text-center">
            <div class="w-8 mr-1 mb-1" v-for="allergen in item.dish.allergens">
              <vx-tooltip :text="allergen.name" position="top">
                <img class="w-full" :src="allergen.image_path" />
              </vx-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="sm:w-1/6 w-full text-right mt-3" v-if="price">
        <span class="rounded-lg bg-petrol text-white px-4 py-2 font-bold float-right sans-serif">
          <span v-if="type === 'menu'">+{{ price }}€</span>
          <span v-else>{{ price }}€</span>
        </span>
      </div>
    </router-link>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
    },
  },
  data () {
    return {};
  },
  computed: {
    ...mapGetters({
      language: 'getCurrentLanguagePublic',
    }),
    price () {
      if (this.type === 'menu') {
        if (this.item.supplement) {
          return this.item.supplement.toFixed(2);
        } else {
          return 0;
        }
      } else {
        return this.item.dish.price.toFixed(2);
      }
    },
  },
  methods: {
    getImage (images) {
      if (images && images[0]) {
        return images[0].path;
      } else {
        return process.env.VUE_APP_IMAGE_PLACEHOLDER;
      }
    },
  },
};
</script>

<style></style>
